import { Children, ReactNode } from 'react';

export function childComponentSelector(
  children: ReactNode,
  matchingComponent: ReactNode,
) {
  const component = Children.map(children, child => child)?.find(
    child => (child as any).type === matchingComponent,
  );

  if (!component) return null;

  return component;
}
